import axios from "../axios/axios";
import OrderSummary from "../components/Orders/OrderSummary";
import { getCookieData, getSessionstoreData } from "../Store/GetData";

export const StatesList = () => {
  return axios.get("/common/stateslist");
};
export const GeoCodeAddress = (data) => {
  return axios.post(`/common/geocode`, data);
};
export const Verifyemail = (data) => {
  return axios.post("/user/auth/email/check", data);
};
export const GenerateOTP = (mobile) => {
  return axios.post("/user/sendotp", mobile);
};
export const ValidateOTP = (mobile) => {
  return axios.post("/user/verifyotp", mobile);
};
export const EmailSignup = (data) => {
  return axios.post("/user/auth/signup", data);
};
export const EmailSignin = (data) => {
  return axios.post("/user/auth/login", data);
};
export const ForgotpasswordConfigure = (data) => {
  return axios.post("/user/auth/forgot-password", data);
};
export const GoogleSignup = (data) => {
  return axios.post("/user/auth/google/signup", data);
};
export const GoogleSignin = (data) => {
  return axios.post("/user/auth/google/login", data);
};
export const FacebookSignup = (data) => {
  return axios.post("/user/auth/facebook/signup", data);
};
export const FacebookSignin = (data) => {
  return axios.post("/user/auth/facebook/login", data);
};
export const ListAllServices = (data) => {
  return axios.post("/provider/categories/services", data);
};
export const ListAllDisabilities = () => {
  return axios.get("/user/onboarding/disabilities");
};
export const UpdateProfile = (data) => {
  return axios.post("/user/profile/personal", data);
};
export const HomeSearch = (data, pageNum) => {
  const listing_type_id = getSessionstoreData("listingTypeID");
  if (listing_type_id === 4) {
    return axios.post(
      `/user/paratransit/pickup/${data}/search?page=${pageNum}`,
      {}
    );
  } else {
    return axios.post(`/user/home/search/tags?page=${pageNum}`, data);
  }
};
export const RelatedSearch = (data, pageNum) => {
  const listing_type_id = getSessionstoreData("listingTypeID");
  // if (listing_type_id === 4) {
  // return axios.post(
  //   `/user/paratransit/pickup/${data}/search?page=${pageNum}`,
  //   {}
  // );
  // }
  // else {
  return axios.post(`/user/home/search/new?page=${pageNum}`, data);
  // }
};
export const SearchService = (data, pageNum) => {
  return axios.post(`/user/home/search/new?page=${pageNum}`, data);
};
export const getListingById = (id) => {
  return axios.get(`/user/listing/${id}/find`);
};
export const ServiceListing = (id) => {
  return axios.get(`/user/home/service/${id}`);
};
export const ProductListing = (id) => {
  return axios.get(`/user/home/product/${id}`);
};
export const TourListing = (id) => {
  return axios.get(`/user/home/tour/${id}`);
};
export const ParaTransitListing = (id) => {
  return axios.get(`/provider/paratransit/${id}`);
};
export const SearchVehicles = (data) => {
  return axios.post(`/user/paratransit/pickup/request`, data);
};
export const ParatransitSearch = (id, pageNum) => {};
export const AddAddress = (data) => {
  return axios.post("/user/profile/address", data);
};
export const UpdateAddress = (data) => {
  return axios.put("/user/profile/address", data);
};
export const DeleteAddress = (id) => {
  return axios.delete(`/user/profile/address/${id}`);
};
export const getProfileInfo = () => {
  const responseData = () => {
    if (getCookieData("individual_token")) {
      return getCookieData("individual_token");
    } else if (getCookieData("corporate_token")) {
      return getCookieData("corporate_token");
    } else {
      return getCookieData("customer_access_token");
    }
  };
  const config = {
    headers: { Authorization: `Bearer ${responseData()}` },
  };
  return axios.get("/csr/user/profile", config);
};
export const ContactInfo = (data) => {
  return axios.post("/user/profile/contact", data);
};
export const FindCareTakerInfo = (data) => {
  return axios.post("/user/profile/caretaker", data);
};
export const MobileUpdate = (data) => {
  return axios.put("user/profile/phone", data);
};
export const EmailUpdate = (data) => {
  return axios.put("/user/profile/email", data);
};
export const PasswordUpdate = (data) => {
  return axios.put("/user/profile/password", data);
};
export const getAllAddress = () => {
  return axios.get("/user/profile/addresses");
};
export const JoinSubscribe = (data) => {
  return axios.post("/prelaunch/subscribe", data);
};
export const ConnectDisability = (data) => {
  return axios.post("/user/onboarding/disabilities/connect", data);
};
export const BookService = (id) => {
  return axios.post(`/user/home/service/${id}/book`);
};
export const BookProduct = (id) => {
  return axios.post(`/user/home/product/${id}/buy`);
};
export const GetWalletBalance = () => {
  return axios.get(`/user/wallet/balance`);
};
export const GetTransaction = () => {
  return axios.get(`/user/wallet/transactions`);
};
export const Addmoney = (data) => {
  return axios.post(`/user/wallet/deposit/create`, data);
};
export const verifypayment = (data) => {
  return axios.post(`/user/wallet/deposit`, data);
};
export const WithDrawmoney = (data) => {
  return axios.post(`/user/wallet/withdraw`, data);
};
export const getCategories = () => {
  return axios.get(`/user/homedata/categories`);
};
export const getallsubCategories = () => {
  return axios.get(`/provider/categories/all`);
};
export const getsubCategories = (id) => {
  return axios.get(`/provider/categories/${id}/classifications`);
};
export const getAllServices = () => {
  return axios.get(`/user/onboarding/services`);
};
export const AddToCart = (data) => {
  return axios.post(`/user/cart/dynamic`, data);
};

export const TempAddToCart = (data) =>{
  return axios.post(`/tempuser/cart/dynamic`, data)
}

export const SubscriptionDetails = () => {
  return axios.get("user/payments/getsubscription")
}
export const SubscriptionCancel = (data) => {
  return axios.post("/user/payments/cancelsubscription", data)
}

export const SubscriptionResume = (data) => {
  return axios.post("/user/payments/resumesubscription", data)
}

export const SubscriptionPause = (data) => {
  return axios.post("/user/payments/pausesubscription", data)
}









export const AddNewService = (data)=>{
  return axios.post(`/user/orderservice/new`, data)
}



export const AddToCartProducts = (data) => {
  return axios.post(`/user/cart/`, data);
};

export const getCartItems = () => {
  return axios.get(`/user/cart`);
};

export const getTempcartItems = (temp_user_id)=>{
  return axios.get(`/tempuser/cart/${temp_user_id}`)
}






export const updateCart = (data) => {
  return axios.put(`/user/cart`, data);
};

export const tempUpdateCart = (data) =>{
  return axios.put(`/tempuser/tempcart/update`, data)
}



export const deleteCartItem = (CartId, ItemId) => {
  return axios.delete(`/user/cart/${CartId}/${ItemId}`);
};

export const tempdeleteCartItem = (CartId, ItemId) => {
  return axios.delete(`/tempuser/tempcart/${CartId}/${ItemId}`);
};







export const flushCart = () => {
  return axios.get(`/user/cart/flush`);
};
export const createOrder = (data) => {
  return axios.post(`/user/order/new`, data);
};
export const createWalletOrder = (data) => {
  return axios.post(`/user/wallet/deposit/create`, data);
};

export const getOrderById = (id) => {
  return axios.get(`/user/order/${id}`);
};
export const AddReview = (id, data) => {
  return axios.post(`/user/listing/${id}/review`, data);
};
export const SendMessageToManager = (id, data) => {
  return axios.post(`/user/order/${id}/message`, data);
};
export const getAllCancelReason = () => {
  return axios.get("/user/orders/cancel/reasons");
};
export const corporateDonateServie = (data) => {
  return axios.post("/store-donations-user-corporate", data);
};
export const getAllListings = () => {
  return axios.get("/provider/home/listings");
};
export const getSlugBy = (data) => {
  return axios.post("/user/home/utility/slug", data);
};
export const getCategoryById = (data) => {
  return axios.post(`/provider/home`, data);
};
export const getAllCategories = () => {
  return axios.get(`/provider/categories/all`);
};
export const endorserApproveService = (data) => {
  return axios.post("/csr/endorser/request/accept", data);
};
export const endorserRejectService = (data) => {
  return axios.post("/csr/endorser/request/reject", data);
};
export const spjobApply = (data) => {
  return axios.post(`/common/job/apply`, data);
};

export const getDashboardRewards = () => {
  return axios.get(`/user/rewards/dashboard`);
};

export const getRewardsByReferal = () => {
  return axios.get(`/user/rewards/referal`);
};

export const getRewardsBySpend = () => {
  return axios.get(`/user/rewards/spend`);
};

export const getRewardsByReview = () => {
  return axios.get(`/user/rewards/review`);
};

export const getRewardsCash = (data) => {
  return axios.post(`/user/rewards/cashvalue`, data);
};

export const getHomeServiceShowcase = () => {
  return axios.get(`/user/home/listings/showcase`);
};

export const getFilterResult = (data) => {
  return axios.post(`/user/home/filter`, data);
};

export const applypromocode = (discount_id, data) => {
  return axios.post(`/user/cart/${discount_id}/promo/apply`, data);
};

export const removepromocode = (discount_id, data) => {
  return axios.post(`/user/cart/${discount_id}/promo/remove`, data);
};

export const getInprogressOrder = () => {
  return axios.get(`/user/orders/inprogress`);
};

export const serviceResheduleRequest = (id, data) => {
  return axios.post(`/user/order/${id}/reschedule/request`, data);
};

export const RequestCancellation = (id, data) => {
  return axios.post(`/user/order/${id}/cancel/request`, data);
};

export const getDisabilities = () => {
  return axios.get(`/user/disabilities/list`);
};

export const sendDisabilityRequest = (data) => {
  return axios.post(`/user/disabilities/new/request`, data);
};

export const verifyEmailOtp = (data) => {
  return axios.post("/user/auth/forgot-password/verify/otp", data);
};

export const resetPassword = (data) => {
  return axios.post("/user/auth/reset-password", data);
};

export const getreferalcode = () => {
  return axios.get("/user/referal/code");
};

export const createCart = (data) => {
  return axios.post("/user/cart/new", data);
};

export const verifyReferal = (data) => {
  return axios.post("/user/referal/code/verify", data);
};

export const sendUnavailablePost = (data) => {
  return axios.post("/user/home/listing/unavailable", data);
};
export const sendMemberPayment = (data) => {
  return axios.post("/user/club/membership/create", data);
};

export const verifyMemberPayment = (data) => {
  return axios.post("/user/club/membership/verify", data);
};

export const verifySlot = (data) => {
  return axios.post("/user/cart/check/slot", data);
};

export const updateSpecialInstruction = (id, data) => {
  return axios.post(`/user/order/${id}/special/instructions`, data);
};

// export const getSlotBydate = (id, date) => {
//   return axios.get(`/user/home/service/${id}/day/${date}/slots`);
// };


  export const getSlotBydate = (id, date)=>{
   return axios.get(`/user/home/service/${id}/day/${date}/slots/dynamic`)
} 
export const spmessageAdmin = (data) => {
  return axios.post(`/common/incoming/message`, data);
};
export const checkcart = () => {
  return axios.post(`/user/cart/check`);
};
export const createOrderPayment = (data) => {
  return axios.post(`/user/order/payment/create`, data);
};
export const BankListService = () => {
  return axios.get("/common/banks/list");
};

export const MembershipService = () => {
  return axios.get("/user/profile/membership");
};

export const BeneficiarySearchService = (data) => {
  return axios.get("/provider/home/listings", data);
};

export const getCollectionListService = (data) => {
  return axios.post("/common/collections/listings", data);
};

// customerdetailsforpayment
export const getCustomerEmailAndNumber = (data) => {
  return axios.put("/user/order/profile/update", data);
};
//homepagenewapi
export const HomePageImageData = (data) => {
  return axios.get("/user/home/today", data);
};
//HomepageNewCollections
export const NewCollectionsPage = (data) => {
  return axios.get(
    `https://api.web.ableaura.com/api/common/collections/${data}`
  );
};
// OrderSummary
export const OrderSummaryData = (data) => {
  return axios.get("/user/orders/summary", data);
};

export const handleSummaryData = (id, data) => {
  return axios.get(`user/orders/summary/${id}`, data);
};

export const getAllOrders = () => {
  return axios.get(`user/orders/`)
};

export const applyvolunteer = (data) =>{
  return axios.post("/common/incoming/volunteer",data)
}

 export const studentCourses = ()=>{
  return axios.get(`/academy/student/courses`)
}; 

export const studentPayment = ()=>{
  return axios.get(`/academy/student/payments/upcoming`)
}; 

export const billingHistory = ()=>{
  return axios.get(`/academy/student/payments/report`)
}; 


export const childImages = (data) =>{
  return axios.post("/academy/student/gallery/upload",data)
}


export const progressChart = (config, franchiseId) => {
  const headers = {
    ...config.headers,
    Authorization: `Bearer ${franchiseId}`,
  };

  return axios.get(`/academy/student/eval/${franchiseId}`, { headers });
};

export const attendanceReport = ()=>{
  return axios.get(`/academy/student/attendance/report`)
}

export const getChildImages = ()=>{
  return axios.get(`/academy/student/gallery/getgallery`)
}

export const academyAtHome = ()=>{
  return axios.get(`/user/tourism/all`)
} 